import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CandidateConferenceComponent } from './candidate-conference.component';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { AudioVideoConferenceModule } from 'src/app/pages/conference-page/conference/audio-video-conference/audio-video-conference.module';

@NgModule({
  declarations: [
    CandidateConferenceComponent
  ],
  imports: [
    CommonModule,
    PipesModule,
    AudioVideoConferenceModule
  ],
  exports: [
    CandidateConferenceComponent
  ],
  entryComponents: [
    CandidateConferenceComponent
  ]
})
export class CandidateConferenceModule { }
